// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MedicalPrivacy = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" {...props}>
		<path
			fill="url(#MedicalPrivacy_tsx__a)"
			d="M33.411 7.364a.804.804 0 0 0-.492-.68C32.651 6.576 26.327 4 20.114 4S7.572 6.576 7.308 6.684a.797.797 0 0 0-.492.68c-.028.368-.656 9.102 1.316 16.363 2.037 7.492 11.27 11.633 11.662 11.805a.826.826 0 0 0 .324.068c.112 0 .22-.024.324-.068.392-.172 9.625-4.313 11.661-11.805 1.972-7.261 1.344-15.995 1.316-16.363h-.008Zm-2.86 15.946c-1.632 6.013-8.821 9.822-10.437 10.61-1.617-.788-8.805-4.597-10.438-10.61C8.036 17.282 8.28 9.95 8.38 7.99c1.556-.585 6.773-2.385 11.734-2.385 4.96 0 10.177 1.804 11.733 2.385.1 1.96.344 9.293-1.296 15.321Zm-6.853-11.169c-.372 0-.756.136-.98.472H21.13v-.756a1.93 1.93 0 0 0 1.132-1.752 1.936 1.936 0 0 0-1.932-1.932 1.936 1.936 0 0 0-1.932 1.932c0 .78.464 1.448 1.132 1.752v.756h-1.625a2.32 2.32 0 0 0-2.312 2.344 2.293 2.293 0 0 0 2.313 2.313h1.624v1.456h-.869a2.32 2.32 0 0 0-2.312 2.344 2.293 2.293 0 0 0 2.313 2.313h.868v1.456h-1.605c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h1.605v.624c0 .44.36.8.8.8.44 0 .8-.36.8-.8v-.624h.432a2.32 2.32 0 0 0 2.312-2.345 2.293 2.293 0 0 0-2.312-2.312h-.432v-1.456h1.296a2.32 2.32 0 0 0 2.312-2.344 2.293 2.293 0 0 0-2.312-2.313H21.13v-1.456h1.952c.236.144.528.232.856.232.48 0 1.728-.208 1.728-1.152 0-1.14-1.888-1.152-1.968-1.152Zm-2.136 11.246c.392 0 .712.32.712.744 0 .392-.32.712-.712.712h-.432v-1.456h.432Zm-2.032-1.6h-.869c-.392 0-.712-.32-.712-.745 0-.392.32-.712.712-.712h.869v1.456Zm2.896-4.517c.392 0 .712.32.712.744 0 .392-.32.712-.712.712H21.13V17.27h1.296Zm-2.896-1.6h-1.625c-.392 0-.712-.32-.712-.745 0-.392.32-.712.712-.712h1.625v1.457Z"
		/>
		<defs>
			<linearGradient
				id="MedicalPrivacy_tsx__a"
				x1={6.699}
				x2={37.882}
				y1={4}
				y2={30.483}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#4A93E5" />
				<stop offset={1} stopColor="#504CCB" />
			</linearGradient>
		</defs>
	</svg>
);
export default MedicalPrivacy;
